import { appName } from '@/utils/appInfo'

export const formatDocumentTitle = (title) => title ? `${title} — ${appName}` : appName

export const setDocumentTitle = (title) => {
  document.title = formatDocumentTitle(title)
}
